import { render, staticRenderFns } from "./search.vue?vue&type=template&id=0791b4b4&"
import script from "./search.vue?vue&type=script&lang=js&"
export * from "./search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0791b4b4')) {
      api.createRecord('0791b4b4', component.options)
    } else {
      api.reload('0791b4b4', component.options)
    }
    module.hot.accept("./search.vue?vue&type=template&id=0791b4b4&", function () {
      api.rerender('0791b4b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/wallets/partials/search.vue"
export default component.exports